import { trim } from './trim';

export const IntToLocalPhone = (value?: string) => {
  if (!value) {
    return '';
  }
  return trim(value)
    ?.replace(/[^+0-9]/g, '')
    ?.replace('+61', '0');
};

export const formatPhoneE164 = (value: string) => {
  return trim(value)
    .replace(/[^+0-9]/g, '')
    .replace(/^0/, '+61');
};
